"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _constants = require("../constants");

/**
 * Flatten the data of a tree structure into a one-dimensional array.
 * @param treeData
 * @returns
 */
function flattenData(treeData) {
  var flattenItems = [];

  function loop(treeData, parentNode) {
    if (!Array.isArray(treeData)) {
      return;
    }

    treeData.forEach(function (rowData) {
      rowData[_constants.PARENT_KEY] = parentNode;
      flattenItems.push((0, _extends2["default"])({}, rowData));

      if (rowData.children) {
        loop(rowData.children, rowData);
      }
    });
  }

  loop(treeData, null);
  return flattenItems;
}

var _default = flattenData;
exports["default"] = _default;